import React from 'react';
import { Card, CardContent, Typography, Button } from '@mui/material';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { Link as RouterLink } from 'react-router-dom';

export default function Donate() {
    return (
        <Card
            elevation={3}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                p: 4,
                height: '100%',
            }}
        >
            <VolunteerActivismIcon
                sx={{
                    fontSize: 60,
                    mb: 2,
                    color: '#002F6C',
                }}
            />
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                Support Our Museum
            </Typography>
            <Typography
                variant="body1"
                color="text.secondary"
                align="center"
                sx={{ mb: 3 }}
            >
                Your gift helps us preserve the historic depot and continue bringing
                Piedmont’s story to life for everyone for years to come.
            </Typography>
            <Button
                variant="contained"
                size="large"
                component={RouterLink}
                to="/donate"
                aria-label="Donate to the museum"
                sx={{
                    mt: 'auto',
                    backgroundColor: '#002F6C',
                    color: 'common.white',
                    '&:hover': { backgroundColor: '#002F6C' },
                }}
            >
                Donate
            </Button>
        </Card>
    );
}
